<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation
    class="dark bg-gray-900 print:hidden"
    [mode]="'over'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="false"
  >
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex h-20 items-center px-8 pt-6">
        <img
          class="h-8 mr-2 select-none pointer-events-none"
          src="/images/logo/MediAstra_Logo.header.png"
          alt="MediAstra Logo"
          draggable="false"
          (contextmenu)="$event.preventDefault()"
        />
        <h1 style="font-weight: bold; font-size: 20px;">MediAstra</h1>
      </div>
    </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex h-full min-h-0 w-full min-w-0 flex-auto flex-col overflow-hidden">
  <!-- Header -->
  <div
    class="customMainHeader fixed z-49 flex h-[44px] w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none md:px-2 print:hidden"
  >
    @if (!isScreenSmall) {
      <!-- Logo and Title - Always visible -->
      <div class="mx-2 flex items-center lg:mr-8" [class.cursor-pointer]="!isOnboardingRoute" (click)="!isOnboardingRoute && navigateToDashboard()">
        <img
          class="mr-2 h-6 md:h-6  lg:h-6  w-auto select-none pointer-events-none"
          src="/images/logo/MediAstra_Logo.header.png"
          alt="MediAstra Logo"
          draggable="false"
          (contextmenu)="$event.preventDefault()"/>
        <h1
          class="font-bold text-lg text-gray-900 md:text-xl lg:text-2xl">
          MediAstra
        </h1>
      </div>
      
      <!-- Horizontal navigation - Hidden during onboarding -->
      @if (!isOnboardingRoute) {
        <app-mega-horizontal-navigation
          class="mr-2"
          [name]="'mainNavigation'"
          [navigation]="navigation.horizontal"
        ></app-mega-horizontal-navigation>
      }
    }

    <!-- Global search container - Hidden during onboarding -->
    @if (!isOnboardingRoute) {
      <div
        class="global-search-container"
        [class.expanded]="isExpanded"
        (click)="$event.stopPropagation()"
      >
        <div class="search-input" title="Search">
          <mat-form-field appearance="outline" class="search-dropdown">
            <mat-select [(value)]="selectedOption" (selectionChange)="onDropdownChange($event.value)">
              <mat-option *ngFor="let option of dropdownOptions" [value]="option">
                {{ option }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-icon class="search-icon" (click)="toggleSearch()">search</mat-icon>
          <input
            class="input-serch"
            type="text"
            placeholder="Search..."
            (focus)="expandSearch()"
            (input)="fetchSuggestions($event.target.value)"
            [(ngModel)]="searchTerm"
          />
          <button
            *ngIf="searchTerm"
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch($event)"
            style="border: 1px solid rgb(212, 212, 212);"
            [matTooltip]="'Clear Text'"
          >
            <span style="font-size: 12px; font-weight: 500;">clear</span>
          </button>
          <button
            mat-icon-button
            aria-label="Close Search"
            (click)="closeSearch($event)"
            [matTooltip]="'Close Search'"
          >
            <mat-icon class="font-bold text-2xl text-red-700">close</mat-icon>
          </button>
        </div>
      </div>
    }

    <!-- Navigation toggle button - Hidden during onboarding -->
    @if (isScreenSmall && !isOnboardingRoute) {
      <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    }
    
    <!-- Components - Hidden during onboarding -->
    @if (!isOnboardingRoute) {
      <div class="customHeaderIcons ml-auto flex shrink-0 items-center">
        <ng-container *ngIf="(stores$ | async) as stores">
          <span
            *ngIf="stores.length && isTenantAdmin"
            class="store-selector-tooltip-host"
            [class.store-selector-locked]="isStoreSelectionLocked"
            [matTooltip]="storeSelectorTooltip(isStoreSelectionLocked)"
            [matTooltipDisabled]="!isStoreSelectionLocked"
            matTooltipPosition="below"
          >
            <mat-form-field
              appearance="fill"
              class="store-selector"
              floatLabel="never"
            >
              <mat-select
                panelClass="header-store-select-panel"
                #storeSelect
                [value]="selectedStoreId$ | async"
                (selectionChange)="onStoreSelectionChange($event.value, storeSelect)"
                [disabled]="!stores.length || isStoreSelectionLocked"
              >
                <mat-option *ngFor="let store of stores" [value]="store.id">
                  {{ store.storeName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </ng-container>

         <button
          *ngIf="isTenantOrStoreAdmin"
          mat-icon-button
          (click)="expandSearch()"
          matTooltip="Global Search"
          aria-label="Open Global Search"
        >
          <mat-icon>search</mat-icon>
        </button>
        
        <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
       
        <!-- <languages></languages> -->
       
        <!-- <shortcuts></shortcuts> -->
        <!-- <messages></messages> -->
        <notifications></notifications>
        <header-system-datetime></header-system-datetime>
        <!-- <button
                  class="lg:hidden"
                  mat-icon-button
                  (click)="quickChat.toggle()"
              >
                  <mat-icon
                      [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                  ></mat-icon>
              </button> -->
        <user></user>
      </div>
    }
  </div>

  <!-- Content: margin clears fixed header; tabs sticky under menu bar -->
  <div class="flex min-h-0 w-full flex-auto flex-col overflow-hidden mt-[44px] print:mt-0">
    @if (!isOnboardingRoute) {
      <div class="modern-workspace-chrome print:hidden">
        <app-workspace-tabs-bar />
      </div>
    }
    <!--
      Routed views (e.g. sales-list) use position:absolute + inset-0. They must be contained
      under the workspace tab strip; otherwise they paint over the tabs.
    -->
    <div class="modern-main-outlet-shell relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
      @if (true) {
        <router-outlet></router-outlet>
      }
    </div>
  </div>

  <!-- Footer -->
  <!-- <div
        class="bg-card relative z-49 flex h-14 w-full flex-0 items-center border-t px-4 dark:bg-transparent sm:h-20 md:px-6 print:hidden"
    >
        <span class="text-secondary font-medium"
            >Fuse &copy; {{ currentYear }}</span
        >
    </div> -->
</div>

<!-- Block interactions while store context is updating (export-style centered panel) -->
@if (isStoreSwitching) {
  <div class="store-switch-overlay" aria-live="polite" aria-busy="true">
    <div class="store-switch-panel">
      <p class="store-switch-caption m-0 w-full">Switching store…</p>
      <div class="store-switch-spinner flex justify-center items-center">
        <app-loading-spinner [diameter]="50"></app-loading-spinner>
      </div>
      <div class="store-switch-progress w-full">
        <div class="store-switch-progress-labels flex justify-between items-baseline gap-3 mb-1">
          <span>Loading…</span>
          <span class="tabular-nums shrink-0">{{ storeSwitchProgressRounded }}&nbsp;%</span>
        </div>
        <div class="store-switch-progress-track">
          <mat-progress-bar mode="determinate" color="primary" [value]="storeSwitchProgress"></mat-progress-bar>
        </div>
      </div>
    </div>
  </div>
}

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
